module.exports = __webpack_public_path__ + "static/S-Factor_Newsletter_July2020-5b31460432cb0e000ca1d0eec596dc6e.pdf";